import { getDateWithSpecificFormat } from '../../../../data-transform';
import { getStatusDescriptionFromStatusValue, getCountryNameByCountryCode, getOrderTypeText, validateEmailAddress } from '../../../../../utils/utility';

const OverflowingStyle = { textOverflow: 'ellipsis', whiteSpace: 'break-spaces' };

export default function orderInformationColumnsSpecification(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];

    config.data.forEach((order, index) => {
        let row = [];
        const rowId = order.orderId;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            let columnDataType = column.data.displayInBodyAs;
            const highlightColumn = column.data.highlightBodyText;

            let columnValue = null;
            let isDisabled = false;
            if (columnDataType === "string") {
                if (columnId === "legalEntityName") {
                    columnValue = order.legalEntity;
                }
                if (columnId === "contactInformation") {
                    columnValue = (<>
                        <div style={OverflowingStyle}><b>Email: </b>{order.email}</div>
                        <div style={OverflowingStyle}><b>Tel: </b>{order.contactNo}</div>
                        <div style={OverflowingStyle}><b>Full Name: </b>{order.firstName + " " + order.lastName}</div>
                    </>);
                }
                if (columnId === "shippingAddress") {
                    isDisabled = order.orderType === "2" ? true : false;
                    columnValue = order.shippingAddress ? getFullAddress(order.shippingAddress) : <></>;
                }
                if (columnId === "billingAddress") {
                    columnValue = order.billingAddress ? getFullAddress(order.billingAddress) : <></>;
                }
            }

            row.push({
                [columnId]: {
                    id: rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: highlightColumn,
                    disabled: isDisabled,
                    clickHandler: (columnDataType !== "string" && config.bodyButtonsHandler) ? event => config.bodyButtonsHandler(event, columnId, index) : null
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}

function getFullAddress(address) {
    return (
        <>
            {
                (address.country && address.country === "ES") ?
                    <>
                        {address.streetName ? <div style={OverflowingStyle}>{address.streetName}</div> : <></>}
                        {address.streetNumber ? <div style={OverflowingStyle}>{address.streetNumber}</div> : <></>}
                    </>
                    :
                    <>
                        {address.addressLine1 ? <div style={OverflowingStyle}>{address.addressLine1}</div> : <></>}
                        {address.addressLine2 ? <div style={OverflowingStyle}>{address.addressLine2}</div> : <></>}
                    </>
            }
            <div style={OverflowingStyle}>{address.city}, {address.state}</div>
            <div style={OverflowingStyle}>{address.country}, {address.zipCode}</div>
        </>
    );
}